import { AutogenModelEdiErrorCode, AutogenRowEdiErrorCode } from "./autogen/AutogenModelEdiErrorCode";

export class ModelEdiErrorCode extends AutogenModelEdiErrorCode<RowEdiErrorCode> {
	constructor() {
		super(RowEdiErrorCode);
	}
}

export class RowEdiErrorCode extends AutogenRowEdiErrorCode {
}